import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';

const StyledCommentDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: clamp(0px, ${props => props.theme.layout(714)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(714)}, 86vw);
  }
  
  ${ComponentStyles}
`;

StyledCommentDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledCommentDialog;
